/**
 * Images Plugin for Lexical Editor
 * Handles image insertion via command
 */

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { 
    $insertNodes,
    $getSelection,
    $isRangeSelection,
    createCommand,
    COMMAND_PRIORITY_EDITOR,
} from 'lexical';
import { useEffect } from 'react';
import { $createImageNode, ImageNode } from '../nodes/ImageNode';

export const INSERT_IMAGE_COMMAND = createCommand('INSERT_IMAGE_COMMAND');

export default function ImagesPlugin() {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (!editor.hasNodes([ImageNode])) {
            throw new Error('ImagesPlugin: ImageNode not registered on editor');
        }

        return editor.registerCommand(
            INSERT_IMAGE_COMMAND,
            (payload) => {
                const { src, altText = '', width, height } = payload;
                const imageNode = $createImageNode({ src, altText, width, height });
                $insertNodes([imageNode]);
                return true;
            },
            COMMAND_PRIORITY_EDITOR
        );
    }, [editor]);

    return null;
}
